module.exports = __webpack_public_path__ + "static/media/fontawesome-webfont.4f0022f2.bin";


//////////////////
// WEBPACK FOOTER
// ./src/CSS/assets-minified/icons/fontawesome/fontawesome-webfont.bin
// module id = ./src/CSS/assets-minified/icons/fontawesome/fontawesome-webfont.bin
// module chunks = 0